// Please replace, if IE11-support isn't required any longer.
//import {useFormContext} from 'react-hook-form';
import {useFormContext} from 'react-hook-form/dist/react-hook-form.ie11';

import * as React from 'react';
import {parse} from 'date-fns';

import {FormField} from './../LayoutComponents';

const TO_DAYS = 1000 * 60 * 60 * 24;

type AlternativeDurationInputProps = {
	getLabel: (key: string) => string;
}
export default ({getLabel}: AlternativeDurationInputProps) => {
	const {setValue, getValues, watch} = useFormContext();

	const name = "quoteRequest.alternativeDuration";
	const dateFormat = 'dd.MM.yyyy';
	const nameFrom = 'quoteRequest.alternativeArrivalTime';
	const nameTo = 'quoteRequest.alternativeDepartureTime';

	const {[nameFrom]: valueFrom, [nameTo]: valueTo} = getValues();

	watch(nameFrom);
	watch(nameTo);

	React.useEffect(() => {
		if (valueFrom && valueTo) {
			const fromDate = parse(valueFrom, dateFormat, new Date()).getTime();
			const toDate = parse(valueTo, dateFormat, new Date()).getTime();

			// Add "1" to show duration days, not nights.
			setValue(name, Math.round((Math.abs(toDate - fromDate) / TO_DAYS)) + 1);
		}
	}, [valueFrom, valueTo]);

	return (
		<FormField
			type="TextInputDisabled"
			name={name}
            readOnly={true}
            deletable={false}
			label={getLabel(name)}
		/>
	);
}
